<template>
  <div class="d-flex justify-content-between">
    {{ thaiDate }}
  </div>
</template>

<script>
export default {
  name: 'ConvertThaidate',
  props: {
    date: { type: String, default: '' },
  },
  data() {
    return {
      thaiDate: '',
    };
  },

  mounted() {
    self = this;
    const res = this.date.split('T');
    const t = res[1].split('.');
    this.thaiDate = `${res[0]} ${t[0]}`;
  },
};
</script>
